import {encodeTranslationText} from '../util'

export const resetForm = (data) => {
  return {
    type: 'RESET_FORM',
  }
}

export const getTranslationsData = (params) => ({apis, getState}) => {
  params.searchText = encodeTranslationText(params.searchText)
  const payload = apis.getTranslations(params).map((x) => x)
  return {
    type: 'GET_TRANSLATIONS',
    payload,
    params,
  }
}



// WEBPACK FOOTER //
// ./src/store/monitoring-translations/actions.js